import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import Typography from '@src/new-components/Typography';
import AlertMessage from '@src/new-components/AlertMessage';
import { WarningRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import { StyledCreateInvoice } from './index.style';

const NewFormExportInvoice = ({ handleChangeInvoice, draftInvoice }) => {
  const { t } = useTranslation();
  const { invoiceError: error } = useSelector((state) => state.order);
  return (
    <StyledCreateInvoice>
      <div>
        <Typography
          component="label"
          variant="body-14-medium"
          color={COLOR.descriptionGray}
        >
          {t('companyName')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          data-id="input-company-name"
          placeholder={t('companyPlaceHolder')}
          className="invoice-input"
          value={draftInvoice.companyName}
          name="companyName"
          onChange={handleChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10 }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '14px',
              height: '40px',
            },
            '& .MuiInputBase-input': {
              height: '40px !important',
              boxSizing: 'border-box',
            },
          }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="company-name"
              data-message={t(error.companyName)}
              data-form-name="payment-info"
            >
              {t(error.companyName)}
            </span>
          }
          error={!!error.companyName}
        />
      </div>
      <div>
        <Typography
          component="label"
          variant="body-14-medium"
          color={COLOR.descriptionGray}
        >
          {t('address')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder={t('companyAddress')}
          className="invoice-input"
          value={draftInvoice.companyAddress}
          name="companyAddress"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '14px',
              height: '40px',
            },
            '& .MuiInputBase-input': {
              height: '40px !important',
              boxSizing: 'border-box',
            },
          }}
          onChange={handleChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10 }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="company-address"
              data-message={t(error.companyAddress)}
              data-form-name="payment-info"
            >
              {t(error.companyAddress)}
            </span>
          }
          error={!!error.companyAddress}
          data-id="input-company-address"
        />
      </div>
      <div>
        <Typography
          component="label"
          variant="body-14-medium"
          color={COLOR.descriptionGray}
        >
          {t('taxNumber')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder={t('taxNumber')}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '14px',
              height: '40px',
            },
            '& .MuiInputBase-input': {
              height: '40px !important',
              boxSizing: 'border-box',
            },
          }}
          className="invoice-input"
          value={draftInvoice.companyTax}
          name="companyTax"
          onChange={handleChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10 }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="tax-code"
              data-message={t(error.companyTax)}
              data-form-name="payment-info"
            >
              {t(error.companyTax)}
            </span>
          }
          error={!!error.companyTax}
          data-id="input-tax-code"
        />
      </div>
      <div>
        <Typography
          component="label"
          variant="body-14-medium"
          color={COLOR.descriptionGray}
        >
          {t('receivedInvoiceEmail')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder="Email"
          className="invoice-input"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '14px',
              height: '40px',
            },
            '& .MuiInputBase-input': {
              height: '40px !important',
              boxSizing: 'border-box',
            },
          }}
          value={draftInvoice.companyEmail}
          name="companyEmail"
          onChange={handleChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10 }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="email-receive-invoice"
              data-message={t(error.companyEmail)}
              data-form-name="payment-info"
            >
              {t(error.companyEmail)}
            </span>
          }
          error={!!error.companyEmail}
          data-id="input-email-receive-invoice"
        />
      </div>
      <div>
        <Typography
          component="label"
          variant="body-14-medium"
          color={COLOR.descriptionGray}
        >
          {t('relatedUnitCode')}
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder={t('relatedUnitCode')}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '14px',
              height: '40px',
            },
            '& .MuiInputBase-input': {
              height: '40px !important',
              boxSizing: 'border-box',
            },
          }}
          className="invoice-input"
          value={draftInvoice.relatedUnitCode}
          name="relatedUnitCode"
          onChange={handleChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10 }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="budget-relationship-unit-code"
              data-message={t(error.relatedUnitCode)}
              data-form-name="payment-info"
            >
              {t(error.relatedUnitCode)}
            </span>
          }
          error={!!error.relatedUnitCode}
          data-id="input-budget-relationship-unit-code"
        />
      </div>
      <AlertMessage
        type="warning"
        startIcon={<WarningRounded className="note-icon-warning" />}
        message={t('noteExportInvoice')}
        textProps={{
          variant: 'body-14-regular',
          color: COLOR.descriptionGray,
          component: 'div',
        }}
        styleWrapper={{
          alignItems: 'flex-start',
        }}
        style={{
          padding: '12px',
          whiteSpace: 'pre-line',
        }}
      />
    </StyledCreateInvoice>
  );
};

export default NewFormExportInvoice;
